"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDate = exports.default = void 0;
const isDefined = v => v !== undefined && v !== null;
const isEmptyString = v => typeof v === 'string' && v.trim().length === 0;
const isDate = v => isDefined(v) && !isEmptyString(v) && new Date(v).toString() !== 'Invalid Date';
exports.isDate = isDate;
const DateUtil = {
  isDate
};
var _default = DateUtil;
exports.default = _default;